<template>
    <router-link class="u-reset"
            :to="link.path"
            :class="rootClasses"
            :style="inlineStyle">
        <div class="tile--content">
            <h1 class="tile--title u-reset">{{ title }}</h1>
            <p class="tile--subtitle u-reset" v-if="subtitle">{{ subtitle }}</p>
            <div class="tile--arrow">
                <base-icon symbol="arrow-forward" size="large"/>
            </div>
        </div>
    </router-link>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';
    import { DEFAULT_THEME } from 'constants/themes';

    export default {
        mixins: [bemMixin('tile')],
        props: {
            title: {
                type: String,
                required: true,
            },
            subtitle: {
                type: String,
                default() {
                    return '';
                },
            },
            /** @type {IImage} */
            image: {
                type: Object,
                required: true,
            },
            theme: {
                type: String,
                default() {
                    return DEFAULT_THEME;
                },
            },
            /** @type {ILink} */
            link: {
                type: Object,
                required: true,
            },
        },
        computed: {
            inlineStyle() {
                return {
                    backgroundImage: `url(${ this.image.url })`,
                };
            },
            rootClasses() {
                return [this.bemRoot, this.bemFacets, this.bemAdd(this.theme)];
            },
        },
    };
</script>
